import "../styles/give.css";

const Give = () => {
  return (
    <section id="give-section">
      <div className="container give-container">
        <div className="give-content">
          <span>Make A Difference</span>

          <h2>
            Help Provide Comfort,
            <br />
            Hope, And Care.
          </h2>

          <p>
            Thanks to Slumberland Furniture and the 40 Winks program, CARPE
            Ministries has helped provide over 100 beds for children in
            Southwest Michigan who did not have one.
          </p>

          <p>
            While Slumberland supplies the beds, CARPE provides the pillows and
            linens. Your gift helps support those in need and improves the
            quality of life for someone in the community.
          </p>

          <div className="give-impact">
            <div>
              <strong>$25</strong>
              <span>Pillow and linens for 1 bed</span>
            </div>

            <div>
              <strong>$50</strong>
              <span>Pillows and linens for 2 beds</span>
            </div>

            <div>
              <strong>$100</strong>
              <span>Pillows and linens for 4 beds</span>
            </div>
          </div>

          <a
            href="https://www.paypal.com/donate/YOUR-PAYPAL-LINK"
            target="_blank"
            rel="noreferrer"
            className="give-btn"
          >
            Donate Through PayPal
          </a>
        </div>
      </div>
    </section>
  );
};

export default Give;